module.exports = __webpack_public_path__ + "assets/img/safari.1315d485.png";